<template>
<div class="flex items-center justify-center w-full h-[112px] bg-brand-gray-900 border border-[#525A58] hover:cursor-pointer">
    <slot />
</div>

</template>

<script>


export default {

};
</script>

<style>
</style>
